import { atom } from 'jotai'
import { alphamapClient } from 'src/clients'
import { selectedEntityId } from 'src/v2/state/owner-reveal'

const propertyTypeBreakdown = atom(async (get) => {
  const entityId = await get(selectedEntityId)
  if (!entityId) {
    return undefined
  }

  return await alphamapClient.ownership.getEntityPropertyTypeBreakdown(entityId)
})

export const totalPropertiesCount = atom(async (get) => {
  const breakdown = await get(propertyTypeBreakdown)
  if (!breakdown) {
    return undefined
  }

  return Object.values(breakdown).reduce((acc, val) => acc + val.count, 0)
})

export const propertyTypesOverview = atom(async (get) => {
  const breakdown = await get(propertyTypeBreakdown)
  const totalProperties = await get(totalPropertiesCount)
  if (!breakdown || !totalProperties) {
    return undefined
  }
  // we want an array of objects that has the property type the count and the percentage
  return Object.entries(breakdown)
    .map(([propertyType, { count }]) => ({
      propertyType,
      count,
      percentage: parseFloat(((count / totalProperties) * 100).toPrecision(1)),
    }))
    .sort((a, b) => b.count - a.count)
})

export const totalAssessedValue = atom(async (get) => {
  const breakdown = await get(propertyTypeBreakdown)
  if (!breakdown) {
    return undefined
  }

  return Object.values(breakdown).reduce((acc, val) => acc + val.value, 0)
})

export const propertyTypesAssesedValue = atom(async (get) => {
  const breakdown = await get(propertyTypeBreakdown)
  const totalValue = await get(totalAssessedValue)
  if (!breakdown || !totalValue) {
    return undefined
  }

  return Object.entries(breakdown)
    .map(([propertyType, { value }]) => ({
      propertyType,
      value,
      percentage: parseFloat(((value / totalValue) * 100).toPrecision(1)),
    }))
    .sort((a, b) => b.value - a.value)
})

export const totalPropertiesSqFt = atom(async (get) => {
  const breakdown = await get(propertyTypeBreakdown)
  if (!breakdown) {
    return undefined
  }

  return Object.values(breakdown).reduce((acc, val) => acc + val.sqft, 0)
})

export const propertyTypesSqFt = atom(async (get) => {
  const breakdown = await get(propertyTypeBreakdown)
  const totalSqFt = await get(totalPropertiesSqFt)
  if (!breakdown || !totalSqFt) {
    return undefined
  }
  return Object.entries(breakdown)
    .map(([propertyType, { sqft }]) => ({
      propertyType,
      sqft,
      percentage: parseFloat(((sqft / totalSqFt) * 100).toPrecision(1)),
    }))
    .sort((a, b) => b.sqft - a.sqft)
})
